import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Main from './pages/Main'
import Login from './pages/Login'
import Game_Statistics from './pages/Game_Statistics';
import Player_Statistics from './pages/Player_Statistics';
import { AuthProvider } from './AuthProvider';
import { RequireAuth } from './RequireAuth';

function App() {
  return (
    <AuthProvider>
      <Router basename="/poker-stats">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Main" element={<RequireAuth><Main /></RequireAuth>} />
          <Route path="/Games_Statistics" element={<RequireAuth><Game_Statistics /></RequireAuth>} />
          <Route path="/Player_Statistics" element={<RequireAuth><Player_Statistics /></RequireAuth>} />
          <Route path="/*" element={<Login />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
